var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", [
    _c("div", { staticClass: "mx-auto max-w-content p-4 desktop:pt-12" }, [
      _c(
        "div",
        { staticClass: "relative flex items-center w-full justify-end h-16" },
        [
          _c(
            "BaseTransition",
            {
              attrs: {
                "enter-duration": 300,
                "leave-duration": 100,
                animation: "fade",
                "enter-active-class": "delay-200"
              }
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.$search.open,
                      expression: "!$search.open"
                    }
                  ],
                  ref: "menu-button",
                  staticClass:
                    "absolute left-0 p-4 rounded text-black z-10 hover:bg-gray-300 desktop:hidden",
                  attrs: { type: "button", "aria-label": "Open menu" },
                  on: {
                    click: function($event) {
                      return _vm.$ui.toggleMenu()
                    }
                  }
                },
                [
                  _c("BaseIcon", {
                    staticClass: "w-6 h-6",
                    attrs: { name: "menu" }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "BaseTransition",
            {
              attrs: {
                "enter-duration": 300,
                "leave-duration": 100,
                animation: "fade",
                "enter-active-class": "delay-200"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$ui.desktop || !_vm.$search.open,
                      expression: "$ui.desktop || !$search.open"
                    }
                  ],
                  staticClass:
                    "\n                        absolute inset-x-16 inset-y-0 z-10 flex justify-center\n                        desktop:relative desktop:inset-auto\n                    "
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "mr-4",
                      attrs: {
                        to: { name: "home" },
                        title:
                          "Media Kraken" +
                          (_vm.$route.name !== "home"
                            ? ' - press "h" to go home'
                            : "")
                      }
                    },
                    [
                      _c("BaseIcon", {
                        staticClass: "w-auto h-16",
                        attrs: { name: "media-kraken" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("AppHeaderSearch"),
          _c("AppHeaderProfile")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }